import React from 'react'

import { ITableHead, ITableHeadProps } from 'components/layout/table/head'
import CheckBox from 'components/ui/checkBox'

export interface ISelectTableHead extends ITableHead {
  linkTo?: string
}

interface IProps extends ITableHeadProps {
  onToggle?: (value: boolean) => void
}

class SelectTableHead extends React.Component<IProps> {
  handleToggle = (isSelected: boolean) => {
    const { onToggle } = this.props

    if (onToggle) {
      onToggle(isSelected)
    }
  }

  public render() {
    const { head } = this.props

    return (
      <div className={`flex items-center mx-48 pb-20 mb-10 border-b-1 border-black`}>
        <div className="mr-10">
          <CheckBox onChange={value => this.handleToggle(value)} />
        </div>
        {head.map(item => {
          return (
            <span
              key={item.key}
              className={`w-${item.col}/12 uppercase tracking-1.5 font-500 text-black text-10 ${
                item.leftAlign ? 'text-left' : 'text-right'
              } first-child:text-left`}
            >
              {item.label}
            </span>
          )
        })}
      </div>
    )
  }
}

export default SelectTableHead
